import React, { useRef, useEffect, useState, forwardRef } from 'react'
import styles from './Timeline.module.scss'
import { bool, number } from 'prop-types'
import moment from 'moment'
import cx from 'classnames'

import {
  TimelineWrapper,
  TimelineBox,
  TimelineTime,
  TimelineDivider,
  TimelineDividers,
  useTimeline
} from 'planby'

export const Timeline = forwardRef(
  (
    {
      isBaseTimeFormat,
      isSidebar,
      dayWidth,
      hourWidth,
      numberOfHoursInDay,
      offsetStartHoursRange,
      sidebarWidth,
      startDate
    },
    ref
  ) => {
    const { time, dividers, formatTime } = useTimeline(
      numberOfHoursInDay,
      isBaseTimeFormat
    )

    const timelineRef = useRef(null)
    const [currentTimeLineLeft, setCurrentTimeLineLeft] = useState(-1)

    useEffect(() => {
      const calculateLeft = () => {
        // const now = moment().add(30, 'minutes') // Add 30 minutes to now - BUG
        const now = moment()
        const start = moment(startDate)
        const diff = now.diff(start, 'minutes')
        return (diff / 60) * hourWidth
      }
      if (timelineRef?.current) {
        if (ref?.current) {
          ref.current.scrollLeft +=
            calculateLeft() - window.innerWidth * 0.75 + 100
        }
        const interval = setInterval(() => {
          const left = calculateLeft()
          setCurrentTimeLineLeft(left)
        }, 1000)
        return () => clearInterval(interval)
      }
    }, [ref, timelineRef, startDate, hourWidth])

    const renderTimeLabel = (i, index) => {
      if (i === 0) {
        const start = moment(startDate)
        const dateAfterHours = start.add(index, 'hours').format('ddd DD')
        return dateAfterHours
      }
      return formatTime(i).toLowerCase()
    }

    const renderTime = (index) => {
      const i = (index + offsetStartHoursRange) % 24
      return (
        <TimelineBox
          key={index}
          width={hourWidth}
          className={cx(styles.TimelineBox, i === 0 && styles.bold)}
        >
          <TimelineTime className={styles.TimelineTime}>
            {renderTimeLabel(i, index)}
          </TimelineTime>
          <TimelineDividers>{renderDividers()}</TimelineDividers>
        </TimelineBox>
      )
    }

    const renderDividers = () =>
      dividers.map((_, index) => (
        <TimelineDivider
          key={index}
          width={hourWidth}
          className={styles.TimelineDivider}
        />
      ))

    return (
      <TimelineWrapper
        dayWidth={dayWidth}
        sidebarWidth={sidebarWidth}
        isSidebar={isSidebar}
        className={styles.TimelineWrapper}
        ref={timelineRef}
      >
        {time.map((_, index) => renderTime(index))}
        {currentTimeLineLeft !== -1 && (
          <div
            className={styles.CurrentTimeLine}
            style={{ left: currentTimeLineLeft }}
          />
        )}
      </TimelineWrapper>
    )
  }
)

Timeline.propTypes = {
  isBaseTimeFormat: bool,
  isSidebar: bool,
  dayWidth: number,
  hourWidth: number,
  numberOfHoursInDay: number,
  offsetStartHoursRange: number,
  sidebarWidth: number,
  startDate: number
}
